<script >
import { ref, provide } from 'vue'
import NavBar from "@/components/NavBar";
import SideBarOffshorePrintingCutting from "@/components/SideBarOffshorePrintingCutting";
import FooterBar from "@/components/FooterBar";

export default {
  components: {
    NavBar,
    SideBarOffshorePrintingCutting,
    FooterBar
  },
  methods: {
    
  },
  setup: {
    
  }
}
</script>

<script setup>
const sidebarVisible = ref(true)
provide('sidebarVisible', sidebarVisible)
</script>

<style scoped src="@/assets/css/inbox.css">
</style>
<style  src="@/assets/css/custom.css">
</style>

<template>
  <div >
    <nav-bar />

    <section class="main-content columns is-fullheight">
			
        <div class="column is-2 sidebar-container" v-if="sidebarVisible" >
          <SideBarOffshorePrintingCutting />
        </div>

    
        <div class=" column is-10" :class="{'is-12':sidebarVisible==false}">
         
          <div class="section">
            <router-view/>
          
          
          </div>
        </div>
      
		</section>

    

    <footer-bar />

  </div>

</template>



